module.exports = __webpack_public_path__ + "static/Verlag-Light.d7856846.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Verlag-Light.otf
// module id = 314
// module chunks = 114276838955818